import PropTypes from 'prop-types'
import { VOUCHER_GENERATE_FLAG } from 'domains/customer-refund-voucher/constants'
import { GenerateStatusBadge } from 'domains/customer-refund-voucher/atoms/'

const propTypes = {
  refundVoucher : PropTypes.object,
  onClickRow    : PropTypes.func
}

const CustomerRefundVoucherTableRow = ({
  refundVoucher,
  onClickRow
}) => {
  const isGenerated = refundVoucher.voucher_generate_flag
  const status      = isGenerated  ? VOUCHER_GENERATE_FLAG.COMPLETED : VOUCHER_GENERATE_FLAG.PENDING
  return (
    <tr onClick={ () => onClickRow(refundVoucher.id) }>
      <td colSpan={ 4 } key={ `customer-refund-${refundVoucher.customer_order_number}` }>{ refundVoucher.customer_order_number }</td>
      <td colSpan={ 4 } key={ `customer-refund-${refundVoucher.customer_name}` }>{ refundVoucher.customer_name }</td>
      <td colSpan={ 4 } key={ `customer-refund-${refundVoucher.voucher_generate_flag}` }>
        <GenerateStatusBadge status={ status }/>
      </td>
    </tr>
  )
}
CustomerRefundVoucherTableRow.propTypes = propTypes
export default CustomerRefundVoucherTableRow